import React from 'react';
import { Eye, Compass, TrendingUp, Clock, Users } from 'lucide-react';

export const BenefitsSection = () => {
  const benefits = [
    {
      icon: Eye,
      title: 'Más claridad',
      description: 'Toda la información importante de tu iglesia disponible en un solo lugar. Sin buscar en múltiples archivos.',
    },
    {
      icon: Compass,
      title: 'Mejor seguimiento',
      description: 'Conoce el proceso de cada persona y comunidad. Asistencia, formación y participación visibles al instante.',
    },
    {
      icon: Clock,
      title: 'Menos trabajo administrativo',
      description: 'Reduce tareas repetitivas y dispersión de información. Centraliza registros en una sola plataforma.',
    },
    {
      icon: TrendingUp,
      title: 'Mejores decisiones',
      description: 'Utiliza información organizada para tomar decisiones pastorales y administrativas con datos reales.',
    },
    {
      icon: Users,
      title: 'Más tiempo para las personas',
      description: 'La tecnología se encarga del orden para que el equipo pueda concentrarse en el ministerio y las personas.',
    },
  ];

  return (
    <section id="beneficios" className="py-20 bg-slate-50 dark:bg-slate-950 border-t border-slate-200/60 dark:border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            Beneficios Clave
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            ¿Qué cambia cuando tu iglesia está organizada?
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {benefits.map((b, idx) => {
            const Icon = b.icon;
            return (
              <div
                key={idx}
                className="bg-white dark:bg-slate-900 p-6 rounded-[2rem] border border-slate-200/80 dark:border-slate-800/80 space-y-4 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white flex items-center justify-center shadow-lg shadow-indigo-500/20">
                  <Icon size={24} />
                </div>
                <h3 className="text-base font-black text-slate-900 dark:text-white tracking-tight">{b.title}</h3>
                <p className="text-xs font-medium text-slate-600 dark:text-slate-400 leading-relaxed">{b.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
